(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/hooks/use-customer-settings.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/hooks/use-customer-settings.js');
'use strict';

const {
  useEffect,
  useState
} = React;
const {
  getCustomersSettingsAsync
} = svs.myProfile.react.shared.customerSettingsService;
const {
  setPlayerSettingsData
} = svs.myProfile.react.store.pd.actions;

const useCustomerSettings = setShouldShowApiError => {
  const dispatch = ReactRedux.useDispatch();
  const {
    playerSettings
  } = ReactRedux.useSelector(state => state.playerDetails);
  const [isPlayerLoggedIn] = useState(svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER));
  useEffect(() => {
    const getData = async () => {
      try {
        svs.myProfile.logger.debug('Fetch Customers Settings data from backend...');
        const {
          settings,
          error
        } = await getCustomersSettingsAsync();
        if (error) {
          svs.myProfile.logger.info('Fetch Customers Settings data from backend... error:', error);
          setShouldShowApiError(true);
        } else {
          svs.myProfile.logger.debug('Fetch Customers Settings data from backend... success');
          dispatch(setPlayerSettingsData(settings));
        }
      } catch (error) {
        svs.myProfile.logger.warn('CommunicationSettings: catch: Fetch Customers Settings error: ', error);
        setShouldShowApiError(true);
        dispatch(setPlayerSettingsData(null));
      }
    };
    if (isPlayerLoggedIn && !playerSettings) {
      getData();
    }
  }, []);
};
useCustomerSettings.propTypes = {
  setPlayerSettingsData: PropTypes.func.isRequired,
  setShouldShowApiError: PropTypes.func.isRequired
};
svs.myProfile.react.shared.hooks.useCustomerSettings = useCustomerSettings;

 })(window);